// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "\n.notification-icon[data-v-2e091061] {\n  font-weight: bold;\n  color: #2e3440;\n  cursor: pointer;\n}\n", ""]);
// Exports
module.exports = exports;
